var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#334599",
    d: "M8.6 20.573l-.868.36c-.672.279-1.449-.03-1.733-.692l-3.086-7.183c-.284-.662.031-1.425.704-1.704l.867-.36c.673-.28 1.45.03 1.734.692l3.085 7.183c.285.662-.03 1.424-.703 1.704",
    transform: "translate(.676 .7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0AA8F0",
    d: "M14.583 1.29L19.4 12.5 6.619 16.123c-1.256.355-2.586-.268-3.094-1.452L1.93 10.96c-.509-1.184-.036-2.555 1.1-3.192L14.583 1.29z",
    transform: "translate(.676 .7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#334599",
    d: "M19.91 13.691c-.656.273-1.413-.03-1.69-.675L13.385 1.763c-.277-.646.03-1.39.687-1.663.657-.272 1.414.03 1.69.675l4.836 11.254c.277.645-.03 1.39-.687 1.662M6.363 16.193c-2.33.967-5.017-.105-6.001-2.396-.984-2.29.107-4.931 2.438-5.899l3.563 8.295z",
    transform: "translate(.676 .7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalMessages);
export default __webpack_public_path__ + "static/media/global_messages.48e3f5173fe23e7a70ca7306add6efcc.svg";
export { ForwardRef as ReactComponent };